import AccountantDashboard from "features/Accountant/components/AccountantDashboard";
import AccountantPayments from "features/Accountant/components/AccountantPayments";
import PaymentDetails from "features/Accountant/components/PaymentDetails";
import AccountantLayout from "features/Accountant/pages/AccountantLayout";
import AdminDashboard from "features/Admin/components/AdminDashboard";
import Configuration from "features/Admin/components/Configuration/Configuration";
import Drivers from "features/Admin/components/Drivers";
import Merchants from "features/Admin/components/Merchants";
import UserManagement from "features/Admin/components/UserManagement";
import AdminLayout from "features/Admin/pages/AdminLayout";
import CodeVerify from "features/Auth/components/CodeVerify";
import ForgetPasswordForm from "features/Auth/components/ForgetPasswordForm";
import LoginForm from "features/Auth/components/LoginForm";
import MerchantRegistration from "features/Auth/components/MerchantRegistration";
import ResetPassword from "features/Auth/components/ResetPassword";
import TermsOfService from "features/Auth/components/TermsOfService";
import PrivacyPolicy from "features/Auth/components/PrivacyPolicy";
import AuthHolder from "features/Auth/pages/AuthHolder";
import FinancialReports from "features/Merchant/components/FinancialReports";
import Inventory from "features/Merchant/components/Inventory";
import InventoryDashboard from "features/Merchant/components/InventoryDashboard";
import SkuImportDetails from "features/Merchant/components/SkuImportDetails";
import MerchantInventoryDetails from "features/Merchant/components/MerchantInventoryDetails";
import MyInventory from "features/Merchant/components/MyInventory";
import MyInventorySkuDetails from "features/Merchant/components/MyInventorySkuDetails";
import MerchantOrders from "features/Merchant/components/MerchantOrders";
import OrderDetails from "features/Merchant/components/OrderDetailes";
import OrderForm from "features/Merchant/components/OrderForm";
import OrderImport from "features/Merchant/components/OrderImport";
import PackagingForm from "features/Merchant/components/PackagingForm";
import DeliveryMethodForm from "features/Merchant/components/DeliveryMethodForm";
import ProfileManagement from "features/Merchant/components/ProfileManagement";
import MerchantLayout from "features/Merchant/pages/MerchantLayout";
import OperatorDashboard from "features/Operator/components/OperatorDashboard";
import SortingOrders from "features/Operator/components/SortingOrders";
import OperatorLayout from "features/Operator/pages/OperatorLayout";
import { createHashRouter } from "react-router-dom";
export const router = createHashRouter([
  {
    element: <AuthHolder />,
    children: [
      { path: "/", element: <LoginForm />, index: true },
      {
        path: "merchant-registration",
        element: <MerchantRegistration />,
      },
      {
        path: "forget-password",
        element: <ForgetPasswordForm />,
      },
      {
        path: "verify-otp/:email?",
        element: <CodeVerify />,
      },
      {
        path: "/reset-password/:token/:email",
        element: <ResetPassword />,
      },
      {
        path: "terms-of-service",
        element: <TermsOfService />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
  {
    element: <MerchantLayout />,
    children: [
      {
        path: "merchant-dashboard/:driver_id?",
        element: <MerchantOrders />,
      },

      {
        path: "order-form",
        element: <OrderForm />,
      },
      {
        path: "order-details/:id",
        element: <OrderDetails />,
      },
      {
        path: "order-import",
        element: <OrderImport />,
      },
      {
        path: "order-packaging/:id",
        element: <PackagingForm />,
      },
      {
        path: "order-delivery/:id",
        element: <DeliveryMethodForm />,
      },
      {
        path: "financial-report",
        element: <FinancialReports />,
      },
      {
        path: "profile-management",
        element: <ProfileManagement />,
      },
      {
        path: "my-inventory",
        element: <MyInventory />,
      },
      {
        path: "my-inventory/sku/:sku",
        element: <MyInventorySkuDetails />,
      },
    ],
  },
  {
    element: <OperatorLayout />,
    children: [
      {
        path: "operator-dashboard",
        element: <OperatorDashboard />,
        index: true,
      },
      {
        path: "sort-order",
        element: <SortingOrders />,
      },
      {
        path: "drivers",
        element: <Drivers />,
      },
      {
        path: "merchants",
        element: <Merchants />,
      },
    ],
  },
  {
    element: <AdminLayout />,
    children: [
      {
        path: "admin-dashboard",
        element: <AdminDashboard />,
        index: true,
      },
      {
        path: "admin-merchant-dashboard/:merchant_id?",
        element: <MerchantOrders />,
      },
      {
        path: "order-form",
        element: <OrderForm />,
      },
      {
        path: "order-details/:id",
        element: <OrderDetails />,
      },
      {
        path: "order-import",
        element: <OrderImport />,
      },
      {
        path: "order-packaging/:id",
        element: <PackagingForm />,
      },
      {
        path: "order-delivery/:id",
        element: <DeliveryMethodForm />,
      },
      {
        path: "user-management",
        element: <UserManagement />,
      },

      {
        path: "payment",
        element: <AccountantPayments />,
      },
      {
        path: "configuration",
        element: <Configuration />,
      },
      {
        path: "inventory",
        element: <Inventory />,
      },
      {
        path: "inventory/:merchantId",
        element: <InventoryDashboard />,
      },
      {
        path: "inventory/:merchantId/sku/:sku",
        element: <SkuImportDetails />,
      },
      {
        path: "drivers",
        element: <Drivers />,
      },
      {
        path: "merchants",
        element: <Merchants />,
      },
      {
        path: "sort-order",
        element: <SortingOrders />,
      },
    ],
  },
  {
    element: <AccountantLayout />,
    children: [
      {
        path: "accountant-dashboard",
        element: <AccountantDashboard />,
        index: true,
      },
      {
        path: "accountant-payment",
        element: <AccountantPayments />,
      },
      {
        path: "payment/:id",
        element: <PaymentDetails />,
      },
    ],
  },
]);
